/**
 * Stub “RPC” for Denmark publish edit: fixed delay, no network.
 * Resolves like a successful API call so the edit modal can show a loader then apply the section.
 */
export const DENMARK_EDIT_SECTION_SELECT_STUB_MS = 500;

export type DenmarkEditSectionSelectStubResult = {
  status: 200;
  delayMs: number;
};

export function fetchDenmarkEditSectionSelectStub(
  _sectionMsId?: number | null,
  delayMs: number = DENMARK_EDIT_SECTION_SELECT_STUB_MS
): Promise<DenmarkEditSectionSelectStubResult> {
  return new Promise((resolve) => {
    window.setTimeout(() => resolve({ status: 200, delayMs }), delayMs);
  });
}

export type DenmarkEditSectionSelectStubFn =
  typeof fetchDenmarkEditSectionSelectStub;
